module.exports = __webpack_public_path__ + "img/icon_time.e8b518c5.svg";